import React from 'react';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import _find from 'lodash/find';
import Button from '@material-ui/core/Button';

import LoadingIndicator from '../LoadingIndicator';
import FormItemContainer from '../Global/Containers/FormItemContainer';
import ProgressButton from '../Global/Buttons/Progress';

import Avatar from './Avatar';

import combineStyles from '../../utils/combineStyles';
import ButtonStyles from '../../styles/button';
import TypographyStyles from '../../styles/typography';
import ProfileStyles from './__styles__/Profile.styles';

export const Profile = ({
  t,
  classes,
  isLoading,
  isResettingPassword,
  referenceFields,
  myUser,
  onResetPassword,
  onChangeLoginEmail,
  onEditProfile
}) => {
  return (
    <FormItemContainer
      title={t('Profile')}
      secondaryAction={
        <Button
          size={'small'}
          color={'primary'}
          className={classnames(classes.smallButton, classes.actionButtons)}
          classes={{
            label: classes.buttonLabel
          }}
          onClick={onEditProfile}
        >
          {t('Edit')}
        </Button>
      }
    >
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <div className={classes.root}>
          <Avatar user={myUser} />
          <div className={classes.details}>
            <p className={classnames(classes.headline8, classes.userName)}>
              {myUser.firstName + ' ' + myUser.lastName}
            </p>
            <p className={classes.body1}>{myUser.loginEmail}</p>
            <p className={classes.body1}>{myUser.phone}</p>
            <p className={classes.body1}>
              {
                (_find(referenceFields.timeZones, {
                  value: myUser.timeZoneId
                }) || {title: ''}).title
              }
            </p>
            <div className={classes.actionContainer}>
              <ProgressButton
                className={classnames(classes.button, classes.action)}
                classes={{
                  label: classes.buttonLabel
                }}
                variant="outlined"
                color="primary"
                onClick={onResetPassword}
                isSubmitting={isResettingPassword}
              >
                {t('Reset Password')}
              </ProgressButton>
              <Button
                className={classnames(classes.button, classes.action)}
                classes={{
                  label: classes.buttonLabel
                }}
                variant="outlined"
                color="primary"
                onClick={onChangeLoginEmail}
              >
                {t('Change Login Email')}
              </Button>
            </div>
          </div>
        </div>
      )}
    </FormItemContainer>
  );
};

export default withStyles(
  combineStyles(ProfileStyles, ButtonStyles, TypographyStyles)
)(withNamespaces()(Profile));
